var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('ProInputAdd', {
    attrs: {
      "list": _vm.inputList,
      "icon": _vm.icon
    },
    on: {
      "onClick": _vm.open
    }
  }), _c('Modal', {
    attrs: {
      "title": _vm.title,
      "width": "900px",
      "mask-closable": false
    },
    on: {
      "on-cancel": _vm.close
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function () {
        return [_c('Button', {
          on: {
            "click": _vm.close
          }
        }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.onSubmit
          }
        }, [_vm._v(` ${$t("kzjg2", "确定")} `)])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('ProChioseAddressBook', {
    attrs: {
      "visible": _vm.visible,
      "tabs": _vm.tabs
    },
    model: {
      value: _vm.checkedList,
      callback: function ($$v) {
        _vm.checkedList = $$v;
      },
      expression: "checkedList"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };